import React from 'react'

const ButtonSuccess = ({ disabled = false, onClick, text }) => {
  return (
    <button
      className={`btn btn-success w-full transform rounded-full py-3 font-bold normal-case text-white drop-shadow-sm transition-all duration-500 hover:scale-105 hover:bg-green-700 ${
        disabled ? 'btn-disabled' : 'btn-active'
      }`}
      disabled={disabled}
      onClick={() => onClick()}
    >
      {text}
    </button>
  )
}

export default ButtonSuccess
